import React, {useEffect, useState} from 'react'
import FormPaymentMethod from '../form/FormPaymentMethod'
import {IDialog} from './ModalPaymentMethodForm'
import Modal from 'react-bootstrap/Modal'
import {Button, Form} from 'react-bootstrap'
import {numberFormat} from '../../utils/Functions'
import {updateIncomeDocument} from '../../api/RevenueApi'
import {IncomeDocumentStateTypes, IncomeDocumentTypes} from '../../constants/Common'
import {useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast'
import {truncateToTwoDecimals} from '../../utils/Helper'
import {paymentFeeSettlementAmount} from '../../utils/paymentEvent'
import {invoiceReceiptAmounts, paidBillingHistoryTotal} from '../../utils/invoiceReceiptAmounts'
import {getPaymentGateways} from '../../modules/apps/finance/core/_requests'

interface IModalOutstandingPayment extends IDialog {
  document: {[key: string]: any}
}

const ModalOutstandingPayment: React.FC<IModalOutstandingPayment> = (props) => {
  const { document } = props
  const navigate = useNavigate()
  const [form, setForm] = useState<any>({})
  // ยืนยันก่อนรับชำระแบบเดียวกับฝั่งรายจ่าย — รับแล้วออก RV ทันทีและแก้ไม่ได้ (1 ต.ค. 2569)
  const [pendingSubmit, setPendingSubmit] = useState<{form: any; remainingAmountResolved: number} | null>(null)
  // ชื่อช่องทางสำหรับหน้าต่างยืนยัน — รายการชำระส่งมาแค่ gatewayId ช่องทางเงินสด/สำรองรับจ่ายไม่มีเลขบัญชีให้แสดง
  const [gatewayNames, setGatewayNames] = useState<Record<string, string>>({})
  useEffect(() => {
    if (!pendingSubmit || Object.keys(gatewayNames).length) return
    getPaymentGateways()
      .then((gateways: any[]) =>
        setGatewayNames(
          Object.fromEntries(
            (gateways || []).map((gateway: any) => {
              // ชื่อแบบเดียวกับ dropdown ใน FormPaymentMethod
              const label =
                gateway.gatewayType === 'bank'
                  ? `${gateway.bankName || ''} ${gateway.accountNo || ''} (${gateway.accountName || gateway.name})`
                  : gateway.gatewayType === 'cash'
                  ? `เงินสด - ${gateway.name}`
                  : gateway.gatewayType === 'e_wallet'
                  ? `e-Wallet - ${gateway.name}`
                  : gateway.gatewayType === 'advance'
                  ? `สำรองรับ/จ่าย - ${gateway.name}`
                  : gateway.name
              return [String(gateway.id), label]
            })
          )
        )
      )
      .catch(() => {})
  }, [pendingSubmit, gatewayNames])
  const payments = (document.incomeDocumentPayments || []).filter(
    (payment: any) => !payment?.cancelledAt && !payment?.cancelled_at
  )
  const billingHistories = document.billingHistories || []
  const currentPayments = form?.incomeDocumentPayments || []
  const currentPaymentFees = form?.incomeDocumentPaymentFees || []
  const currentPaymentDeductions = form?.incomeDocumentPaymentDeductions || []
  const billingAlreadyPaidTotal = paidBillingHistoryTotal(billingHistories)
  const invoiceAmounts = invoiceReceiptAmounts(document)
  const isInvoice = document.type === IncomeDocumentTypes.INVOICE
  // ใช้ยอดเต็มเพื่อตัด payment.amount + WHT และใช้ยอดสุทธิแสดงให้ผู้รับเงินเห็น
  const baseAmount = truncateToTwoDecimals(
    isInvoice ? invoiceAmounts.grossAmount : (document.netAmount ?? document.totalAmount ?? 0)
  ) - billingAlreadyPaidTotal
  let remainingAmount = baseAmount
  let maximumPayingAmount = isInvoice
    ? invoiceAmounts.settlementAmount - billingAlreadyPaidTotal
    : baseAmount

  if (payments?.length) {
    payments.map((item: any) => {
      remainingAmount = remainingAmount - truncateToTwoDecimals(item?.amount) - truncateToTwoDecimals(item?.whTaxPrice)
      maximumPayingAmount = maximumPayingAmount - truncateToTwoDecimals(item?.amount)
    })
  }

  const settledByExistingFees = paymentFeeSettlementAmount(document.incomeDocumentPaymentFees || [])
  remainingAmount -= settledByExistingFees
  maximumPayingAmount -= settledByExistingFees

  // FormPaymentMethod ใช้ totalAmount เป็นฐานตั้งยอดชำระและ WHT ของแถวใหม่
  // ค่านี้ต้องหักเฉพาะรายการที่บันทึกแล้วเท่านั้น ห้ามหักค่าที่กำลังกรอกใน modal
  // ไม่เช่นนั้น parent จะส่งยอดลดลงกลับไปให้ form ทุกครั้งที่เลือกช่องทางชำระ
  // แล้วเกิดวงจร reset ยอดชำระไปมา
  const paymentFormTotalAmount = remainingAmount

  if (currentPayments?.length && currentPayments?.[0] !== undefined) {
    currentPayments.map((item: any) => {
      const amount = truncateToTwoDecimals(item?.amount || 0)
      const whTaxPrice = truncateToTwoDecimals(item?.whTaxPrice || 0)

      remainingAmount = remainingAmount - (amount + whTaxPrice)
    })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()

    let formRemainingAmount = remainingAmount
    if (form.incomeDocumentPayments.length) {
      form.incomeDocumentPayments.map((item: any) => {
        formRemainingAmount = remainingAmount - item?.amount
      })
    }

    let _form = {...form}
    const totalFees = currentPaymentFees.reduce((a: any, b: any) => a + (b.reason === 1 ? Number(b.amount) : Number(b.amount) * -1), 0)
    let totalDeductions = currentPaymentDeductions.reduce((a: any, b: any) => {
      if (b.type === 'credit') {
        return a + b.amount
      }

      return a - b.amount
    }, 0)

    console.log(_form)

    // NOTE:: แปลงเลขติดลบให้เอาเข้ามาเป็น +
    // ถ้าเจ๊งแจ้งโอ็คได้เลยครับ อาจจะต้องหาท่าอื่น กลัวกระทบ
    totalDeductions = Math.abs(totalDeductions)
    const remainingAmountResolved = remainingAmount + truncateToTwoDecimals(totalFees) - truncateToTwoDecimals(totalDeductions)
    if (remainingAmountResolved <= 0) {
      _form = {
        ..._form,
        state: document.type === IncomeDocumentTypes.DEPOSIT
          ? IncomeDocumentStateTypes.AWAIT_DEDUCT
          : IncomeDocumentStateTypes.PAID,
      }
    }

    if (document.type === IncomeDocumentTypes.BILLING && (remainingAmountResolved !== 0)) {
      return toast.error('ไม่สามารถชำระเงินบางส่วนหรือติดลบได้')
    }

    setPendingSubmit({form: _form, remainingAmountResolved})
  }

  const submitConfirmed = () => {
    if (!pendingSubmit) return
    const {form: _form, remainingAmountResolved} = pendingSubmit
    setPendingSubmit(null)

    updateIncomeDocument(
      document.id,
      _form,
      (res: any) => {
        if (_form.incomeDocumentPaymentDeductions) {
          _form.incomeDocumentPaymentDeductions.map((paymentDeduction: any) => {
            updateIncomeDocument(
              paymentDeduction.incomeDocumentId,
              {state: IncomeDocumentStateTypes.DEDUCTED},
              (res: any) => {
                console.log(res)
              }
            )

            return
          })
        }

        if (remainingAmountResolved <= 0) {
          props.onSubmitSuccess(res)
          return
        }

        navigate(0)
      }
    )
  }

  const confirmPayments: any[] = pendingSubmit?.form?.incomeDocumentPayments || []
  const confirmReceived = confirmPayments.reduce((sum, item) => sum + truncateToTwoDecimals(item?.amount || 0), 0)
  const confirmWhTax = confirmPayments.reduce((sum, item) => sum + truncateToTwoDecimals(item?.whTaxPrice || 0), 0)
  const confirmFees = (pendingSubmit?.form?.incomeDocumentPaymentFees || []).reduce(
    (sum: number, item: any) => sum + (item.reason === 1 ? Number(item.amount) : Number(item.amount) * -1),
    0
  )
  const confirmDeductions = Math.abs(
    (pendingSubmit?.form?.incomeDocumentPaymentDeductions || []).reduce(
      (sum: number, item: any) => (item.type === 'credit' ? sum + Number(item.amount) : sum - Number(item.amount)),
      0
    )
  )
  const confirmRemaining = Math.max(pendingSubmit?.remainingAmountResolved || 0, 0)

  return (
    <>
    <Modal show={!!pendingSubmit} onHide={() => setPendingSubmit(null)}>
      <Modal.Header closeButton>
        <Modal.Title className='text-danger'>ยืนยันการรับชำระ</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{maxHeight: '60dvh', overflowY: 'auto'}}>
        <div className='mb-3'>
          กรุณาตรวจสอบข้อมูลการรับชำระก่อนดำเนินการ
        </div>
        <hr />
        <div className='mb-2'>
          <b>เลขที่เอกสาร:</b> #{document.code}
        </div>
        {!!confirmPayments.length && (
          <div className='mb-2'>
            <b>ช่องทางการรับชำระ:</b>
            <ul className='mb-0'>
              {confirmPayments.map((item: any, idx: number) => (
                <li key={idx} className='mb-1'>
                  {item?.chequeNumber
                    ? `เช็คเลขที่ ${item.chequeNumber}`
                    : item?.accountNo
                    ? `${item?.bank || ''} ${item.accountNo}${item?.accountName ? ` (${item.accountName})` : ''}`
                    : gatewayNames[String(item?.gatewayId)] || item?.bank || 'ไม่ระบุช่องทาง'}
                  {` — ${numberFormat(item?.amount || 0)} บาท`}
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className='mb-2'>
          <b>ยอดรับชำระรวม:</b> {numberFormat(confirmReceived)} บาท
        </div>
        {confirmWhTax > 0 && (
          <div className='mb-2'>
            <b>ภาษีหัก ณ ที่จ่าย:</b> {numberFormat(confirmWhTax)} บาท
          </div>
        )}
        {confirmFees !== 0 && (
          <div className='mb-2'>
            <b>ค่าธรรมเนียม/ปรับปรุง:</b> {numberFormat(confirmFees)} บาท
          </div>
        )}
        {confirmDeductions !== 0 && (
          <div className='mb-2'>
            <b>ตัดชำระ:</b> {numberFormat(confirmDeductions)} บาท
          </div>
        )}
        <div className='mb-2'>
          <b>ยอดคงค้างหลังรับชำระ:</b> {numberFormat(confirmRemaining)} บาท{' '}
          <span className={confirmRemaining > 0 ? 'text-warning' : 'text-success'}>
            ({confirmRemaining > 0 ? 'รับชำระบางส่วน' : 'รับชำระครบ'})
          </span>
        </div>
        <div className='pt-3 text-danger'>
          ⚠️ ยืนยันจะรับชำระตามรายการข้างต้นหรือไม่?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={() => setPendingSubmit(null)}>
          ยกเลิก
        </Button>
        <Button variant='danger' onClick={submitConfirmed}>
          ยืนยันการรับชำระ
        </Button>
      </Modal.Footer>
    </Modal>
    <Modal size={'lg'} show={props.show} onHide={() => props.onClose()}>
      <Modal.Header closeButton className={'flex-column py-2 align-items-start'}>
        <Modal.Title>รับชำระเงิน #{document.code}</Modal.Title>
        <div className={'fs-5'}>มูลค่าลูกหนี้ที่สามารถรับชำระได้ทั้งสิ้น <strong>{numberFormat(maximumPayingAmount)}</strong> บาท</div>
      </Modal.Header>
      <Modal.Body className={'p-2'}>
        <Form onSubmit={handleSubmit}>
          <FormPaymentMethod
            isPaying
            disableTitle
            documentId={document.id}
            currentDocument={document}
            remainingAmount={remainingAmount}
            totalAmount={paymentFormTotalAmount}
            currentDocumentFormItems={props.document.incomeDocumentItems}
            onFormChange={(data) => {
              setForm({...form, ...data})
            }}
            onCreatingMethod={() => {}}
          />
          <div className={'text-end mt-8'}>
            <Button disabled={!form.incomeDocumentPayments?.length} type={'submit'} variant={'info'}>{'รับชำระเงิน'}</Button>
            <Button variant={'secondary'} className={'ms-2'} onClick={props.onClose}>{'ปิด'}</Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
    </>
  )
}

export default ModalOutstandingPayment
